import { render, staticRenderFns } from "./Lottie.vue?vue&type=template&id=78ea8c28&"
import script from "./Lottie.vue?vue&type=script&lang=ts&"
export * from "./Lottie.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports